import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Radio, Select, Tabs } from 'antd';
import { StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { updateGroupProperties } from 'redux/slices/getOuGroups';
import TextArea from 'antd/es/input/TextArea';
import { useRefreshGroupTab } from 'component/table_component/groupData/refreshGroupData';
import TransferDataComponent from 'component/form_component/transferDataBox';
import TabPane from 'antd/es/tabs/TabPane';
import {
  FormHeader,
  FormItem,
  FormSubmitButtonConatainer,
  ModalFormContainer,
  RowWrapper,
} from 'component/form_component/style';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { ReactComponent as UserIcon } from 'assets/images/SVG/icons/user-icon.svg';
import { ReactComponent as GroupIcon } from 'assets/images/SVG/icons/group-header-icon.svg';
import { InputPatternRuleAD } from 'utils/input_pattern';
import Swal from 'sweetalert2';

export default function UpdateGroupProperties({ handleCancel, ...record }) {
  const refreshGroupTab = useRefreshGroupTab();
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const [form] = Form.useForm();
  const [formTab1] = Form.useForm();
  const selectedNode = useSelector((state) => state.selectedNode);
  const [activeTab, setActiveTab] = useState('1');
  const [removedGroups, setRemovedGroups] = useState([]);
  const [assignedGroups, setAssignedGroups] = useState([]);
  const [removedUsers, setRemovedUsers] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const { userInGroup } = useSelector((state) => state.getUserInGroupData);
  const { childOuDropdown, domainContainers } = useSelector((state) => state.getChildOuData);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  const { userNotInGroup } = useSelector((state) => state.getUserNotInGroupData);
  const { membersOfGroup, membersOfExceptGroup } = useSelector((state) => state.usersGroupSlice);

  useEffect(() => {
    form.setFieldsValue({
      fqdn: selectedNode.domainName,
    });
  }, [selectedNode, form]);

  useEffect(() => {
    form.setFieldsValue({
      groupScope: record.groupScope ? record.groupScope : 1,
    });
    form.setFieldsValue({
      groupType: record.groupType ? record.groupType : 1,
    });
  }, [record.groupScope, record.groupType]);

  let userIndexCounter = 1;
  let userMergedArray = [];

  userMergedArray = [
    ...userInGroup.map((group) => ({
      title: group.name,
      dn: group.distinguishedName,
      groupAvailability: true,
      key: String(userIndexCounter++),
      render: () => (group.type === 'person' ? <UserIcon /> : <GroupIcon />),
    })),
    ...userNotInGroup.map((group) => ({
      title: group.name,
      dn: group.distinguishedName,
      groupAvailability: false,
      key: String(userIndexCounter++),
      disabled: group.isDisable || group.isbuiltin,
      render: () => (group.type === 'person' ? <UserIcon /> : <GroupIcon />),
    })),
  ];

  const keysWithTrueUserAvailability =
    userMergedArray && userMergedArray.filter((item) => item.groupAvailability).map((item) => item.key);
  const handleUserTransferChange = (nextTargetKeys, direction, moveKeys) => {
    setAssignedUsers(nextTargetKeys);
    setRemovedUsers(moveKeys);
  };

  let groupMergedArray = [];
  let groupindexCounter = 1;

  groupMergedArray = [
    ...membersOfGroup.map((group) => ({
      title: group.groupName,
      dn: group.distinguishedName,
      groupAvailability: true,
      key: String(groupindexCounter++),
    })),
    ...membersOfExceptGroup.map((group) => ({
      title: group.groupName,
      dn: group.distinguishedName,
      isDisable: group.isDisable,
      groupAvailability: false,
      key: String(groupindexCounter++),
      disabled: group.isDisable,
    })),
  ];

  const keysWithTrueGroupAvailability =
    groupMergedArray && groupMergedArray.filter((item) => item.groupAvailability).map((item) => item.key);
  const handleGroupTransferChange = (nextTargetKeys, direction, moveKeys) => {
    setAssignedGroups(nextTargetKeys);
    setRemovedGroups(moveKeys);
  };

  const onFinish = async (values) => {
    let groupData = { ...values, fqdn: selectedNode.domainName, groupDn: record.dnName };
    const addGroupNames = [];
    assignedGroups.forEach((item) => {
      if (!removedGroups.includes(item)) {
        addGroupNames.push(item.dn);
      }
    });
    const removeGroupNames = [];
    removedGroups.forEach((item) => {
      if (!assignedGroups.includes(item)) {
        removeGroupNames.push(item.dn);
      }
    });
    const addMultipleUserToGroup = [];
    assignedUsers.forEach((item) => {
      if (!removedUsers.includes(item)) {
        addMultipleUserToGroup.push(item.dn);
      }
    });
    const removeMultipleUserToGroup = [];
    removedUsers.forEach((item) => {
      if (!assignedUsers.includes(item)) {
        removeMultipleUserToGroup.push(item.dn);
      }
    });
    let inputValue = values.groupNamePreWin;
    if (inputValue.match(InputPatternRuleAD.pattern)) {
      const result = await Swal.fire({
        icon: 'info',
        html: `The Group Name (Pre Win 2000) ${inputValue} ${InputPatternRuleAD.message}`,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        showCancelButton: true,
        cancelButtonColor: 'green',
        width: '500px',
        heightAuto: false,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
      });
      if (result.isConfirmed) {
        inputValue = inputValue.replace(InputPatternRuleAD.pattern, '_');
        form.setFieldsValue({
          groupNamePreWin: inputValue,
        });
        groupData = { ...groupData, groupNamePreWin: inputValue };
      } else if (!result.isConfirmed) {
        return;
      }
    }
    const value = {
      groupData,
      addGroupNames,
      removeGroupNames,
      addMultipleUserToGroup,
      removeMultipleUserToGroup,
    };
    try {
      setLoading(true);
      const sweetAlert = await dispatch(updateGroupProperties(value));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        handleCancel();
        Navigate('/groupdata');
      } else if (sweetAlert.payload && sweetAlert.payload.response.status === 409) {
        SweetSweetAlert({ sweetData: sweetAlert.payload.response.data, icon: 'warning', buttonColor: 'orange' });
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoading(false);
    }
    refreshGroupTab();
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  return (
    <ModalFormContainer className='af-modal-container af-updategroup-modal-container'>
      {loading && <ModalOpenLoader />}
      <FormHeader className='af-form-header af-updategroup-form-header'>Update Group : {record.groupName}</FormHeader>
      <Form
        className='af-form af-updategroup-form'
        form={form}
        layout='vertical'
        name='register'
        onFinish={onFinish}
        initialValues={{
          groupName: record.groupName ? record.groupName : '',
          groupNamePreWin: record.namePreWin ? record.namePreWin : '',
          ouName: record.groupScope === 0 ? null : /OU=|CN=/.test(record.ouName) ? record.ouName : null,
          email: record.email ? record.email : '',
          description: record.description ? record.description : '',
          groupScope: record.groupScope,
          groupType: record.groupType,
          notes: record.notes ? record.notes : '',
        }}
        scrollToFirstError
        size='large'
      >
        <Tabs
          className='af-form-tab af-updategroup-form-tab'
          activeKey={activeTab}
          defaultActiveKey='1'
          onChange={handleTabChange}
          tabPosition='top'
          tabBarGutter={20}
        >
          <TabPane
            tab='Account'
            key='1'
            className='af-form-tab-tabpane af-updategroup-form-tab-tabpane af-updategroup-form-tab-tabpane_account'
          >
            <RowWrapper className='af-form-row-wraper af-updategroup-form-row-wraper af-updategroup-form-row-wraper-wrap1'>
              <FormItem
                className='af-form-item af-updategroup-form-item af-updategroup-form-item-groupname'
                key='groupName'
                name='groupName'
                label='Group Name'
                rules={[
                  {
                    required: true,
                    message: `Please Enter the Group Name`,
                  },
                ]}
              >
                <Input className='af-form-input af-updategroup-form-input af-updategroup-form-input_groupname' />
              </FormItem>
              <FormItem
                className='af-form-item af-updategroup-form-item af-updategroup-form-item-groupname_prewin'
                key='groupNamePreWin'
                name='groupNamePreWin'
                label='Group Name (Pre Win 2000)'
              >
                <Input className='af-form-input af-updategroup-form-input af-updategroup-form-input_groupname_prewin' />
              </FormItem>
            </RowWrapper>
            <RowWrapper className='af-form-row-wraper af-updategroup-form-row-wraper af-updategroup-form-row-wraper-wrap3'>
              {record.systemFlags !== 1 && (
                <FormItem
                  key='ouName'
                  name='ouName'
                  label='OU'
                  className='af-form-item af-updategroup-form-item af-updategroup-form-item-ou'
                >
                  <Select
                    className='af-form-select af-updategroup-form-select af-updategroup-form-select_ou'
                    disabled={record.groupScope === 0}
                    allowClear
                    showSearch
                    placeholder='Select a Ou'
                  >
                    {domainContainers
                      .filter(
                        (container) => typeof container === 'object' && container.distinguishedName.includes('CN=Users')
                      )
                      .map((container) => (
                        <Select.Option
                          className='af-form-select-option af-updategroup-form-select-option'
                          key={container.distinguishedName}
                          value={container.distinguishedName}
                        >
                          {container.name} (Container)
                        </Select.Option>
                      ))}
                    {localStorage.getItem('role') === 'ouadmin' && (
                      <Select.Option
                        className='af-form-select-option af-updategroup-form-select-option'
                        key={adminOuName.dnName}
                        value={adminOuName.dnName}
                      >
                        {adminOuName.name}
                      </Select.Option>
                    )}
                    {childOuDropdown.map((ou) => (
                      <Select.Option
                        className='af-form-select-option af-updategroup-form-select-option'
                        key={ou.dnName}
                        value={ou.dnName}
                      >
                        {ou.name}
                      </Select.Option>
                    ))}
                  </Select>
                </FormItem>
              )}
              <FormItem
                className={`${
                  record.systemFlags === 1 ? 'oddFormItem' : ''
                } af-form-item af-updategroup-form-item af-updategroup-form-item-email`}
                key='email'
                name='email'
                label='E-mail'
                rules={[
                  {
                    type: 'email',
                    message: `Please Enter the E-mail`,
                  },
                ]}
              >
                <Input className='af-form-input af-updategroup-form-input af-updategroup-form-input_email' />
              </FormItem>
            </RowWrapper>
            <RowWrapper
              className={`${
                record.systemFlags === 1 ? 'disabled-row' : ''
              } af-form-item af-form-row-wraper af-updategroup-form-row-wraper af-updategroup-form-row-wraper-wrap4`}
            >
              <FormItem
                className='af-form-item af-updategroup-form-item af-updategroup-form-item-groupscope'
                key='groupScopes'
                name='groupScope'
                label='Group Scope'
              >
                <Radio.Group
                  className='af-form-radio af-updategroup-form-radio af-updategroup-form-radio_groupscope'
                  defaultValue={record.groupScope}
                >
                  <Radio
                    className='af-form-radio-option af-updategroup-form-radio-option af-updategroup-form-radio-option_groupscope'
                    disabled={record.groupScope === 2}
                    value={1}
                  >
                    {record.groupScope === 0 ? 'BuiltIn Local' : 'Domain Local'}
                  </Radio>
                  <Radio
                    className='af-form-radio-option af-updategroup-form-radio-option af-updategroup-form-radio-option_groupscope'
                    disabled={record.groupScope === 1}
                    value={2}
                  >
                    Global
                  </Radio>
                  <Radio
                    className='af-form-radio-option af-updategroup-form-radio-option af-updategroup-form-radio-option_groupscope'
                    value={3}
                  >
                    Universal
                  </Radio>
                </Radio.Group>
              </FormItem>
              <FormItem
                className='af-form-item af-updategroup-form-item af-updategroup-form-item-grouptypes'
                key='groupType'
                name='groupType'
                label='Group Type'
              >
                <Radio.Group
                  className='af-form-radio af-updategroup-form-radio af-updategroup-form-radio_grouptype'
                  defaultValue={record.groupType}
                >
                  <Radio
                    className='af-form-radio-option af-updategroup-form-radio-option af-updategroup-form-radio-option_grouptype'
                    value={1}
                  >
                    Security
                  </Radio>
                  <Radio
                    className='af-form-radio-option af-updategroup-form-radio-option af-updategroup-form-radio-option_grouptype'
                    value={2}
                  >
                    Distribution
                  </Radio>
                </Radio.Group>
              </FormItem>
            </RowWrapper>
            <RowWrapper className='af-form-row-wraper af-updategroup-form-row-wraper af-updategroup-form-row-wraper-wrap5'>
              <FormItem
                className='af-form-item af-updategroup-form-item af-updategroup-form-item-description'
                key='description'
                name='description'
                label='Description'
              >
                <TextArea
                  rows={2}
                  className='af-form-input af-updategroup-form-input af-updategroup-form-textarea_description'
                />
              </FormItem>
              <FormItem
                className='af-form-item af-updategroup-form-item af-updategroup-form-item-notes'
                key='notes'
                name='notes'
                label='Notes'
              >
                <TextArea
                  className='af-form-textarea af-updategroup-form-textarea af-updategroup-form-textarea_description'
                  rows={2}
                />
              </FormItem>
            </RowWrapper>
          </TabPane>
          <TabPane
            tab='Group Members'
            key='2'
            className='af-form-tab-tabpane af-updategroup-form-tab-tabpane af-updategroup-form-tab-tabpane_groupmembers'
          >
            <FormItem
              label='Group Members'
              className='af-form-item af-updategroup-form-item af-updategroup-form-item-groupmembers'
            >
              <Form className='af-updategroup-form af-updategroup-form-groupmembers' form={formTab1}>
                <TransferDataComponent
                  className='af-updategroup-transferbox af-updategroup-transferbox-groupmembers'
                  leftBoxData={userMergedArray}
                  rightBoxData={keysWithTrueUserAvailability}
                  onChange={handleUserTransferChange}
                  leftBoxTitle={'Members Not in Group'}
                  rightBoxTitle={'Members of this Group'}
                  height={500}
                />
              </Form>
            </FormItem>
          </TabPane>
          <TabPane
            tab='Member Of'
            key='3'
            className='af-form-tab-tabpane af-updategroup-form-tab-tabpane af-updategroup-form-tab-tabpane_memberof'
          >
            {record.systemFlags !== 1 ? (
              <FormItem
                label='Assign Group'
                className='af-form-item af-updategroup-form-item af-updategroup-form-item-assigngroup'
              >
                <TransferDataComponent
                  className='af-updategroup-transferbox af-updategroup-transferbox-assigngroup'
                  leftBoxData={groupMergedArray}
                  rightBoxData={keysWithTrueGroupAvailability}
                  onChange={handleGroupTransferChange}
                  leftBoxTitle={'Available Group(s)'}
                  rightBoxTitle={'Assigned Group(s)'}
                  height={500}
                />
              </FormItem>
            ) : (
              <p className='af-updategroup-assigngroup-nodata' style={{ fontSize: '16px', marginBottom: '10px' }}>
                Builtin groups cannot be added to other groups
              </p>
            )}
          </TabPane>
        </Tabs>
        {!(record.systemFlags === 1 && activeTab === '3') && (
          <FormSubmitButtonConatainer className='af-form-button-submit-wrapper af-updategroup-form-button-submit-wrapper'>
            <StyledButton
              type='primary'
              htmlType='submit'
              className='af-form-button af-updategroup-form-button af-updategroup-form-button_submit'
            >
              Submit
            </StyledButton>
          </FormSubmitButtonConatainer>
        )}
      </Form>
    </ModalFormContainer>
  );
}
